import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import "./NewTax.css";
import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";

function Loader(props) {
  return (
    <Box
      sx={{
        position: "relative",
        top: "2px",
      }}
    >
      <CircularProgress
        variant="determinate"
        sx={{
          color: (theme) =>
            theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
        }}
        size={20}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light" ? "var(--color-brand)" : "#308fe8",
          animationDuration: "550ms",
          position: "absolute",
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={20}
        thickness={4}
        {...props}
      />
    </Box>
  );
}
const initialData = {
  charge_name: "",
  charge_amount: "",
};

export default function AdditionalCharge({
  open,
  setOpen,
  additionalCharges,
  setAdditionalCharges,
  setAdditionalChargesData,
  setFinalTotal,
  setNewlyAddedCharges,
}) {
  const [data, setData] = useState(initialData);
  const { t } = useTranslation("finances");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setData(initialData);
    setOpen(false);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  function handleSave() {
    // Find the maximum Id value in the existing objects
    const maxId = additionalCharges.reduce((max, obj) => {
      return obj.Id > max ? obj.Id : max;
    }, 0);

    const newTax = {
      Id: maxId + 1,
      Charge: data?.charge_amount,
      NameEn: data?.charge_name,
    };
    setNewlyAddedCharges((prevCharges) => {
      return [...prevCharges, maxId + 1];
    });
    setAdditionalCharges([...additionalCharges, newTax]);
    setAdditionalChargesData((prevData) => {
      return { ...prevData, [data?.charge_name]: data?.charge_amount };
    });
    setFinalTotal((finalTotal) => {
      return {
        ...finalTotal,
        [data?.charge_name]: Number(data?.charge_amount),
      };
    });
    handleClose();
  }
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="admnnew__tax_modal">
          <div className="admnnew__tax_modalheading">
            {t("invoice.newCharge.addCharge")}
          </div>
          <div className="admnnew__tax_modalcontent">
            <div className="admnedit__user_modalrow"></div>

            <div className="admnnew__tax_modalrow">
              <div className="admnnew__tax_modalinputwrap">
                <label className="admnnew__tax_modallbl">
                  {t("invoice.newCharge.chargeName")}
                </label>
                <input
                  className="admnnew__tax_modalinput"
                  placeholder={t("invoice.newCharge.chargeNamePlaceholder")}
                  name="charge_name"
                  value={data.charge_name}
                  onChange={handleChange}
                  type="text"
                />
              </div>
            </div>
            <div className="admnnew__tax_modalrow">
              <div className="admnnew__tax_modalinputwrap">
                <label className="admnnew__tax_modallbl">
                  {t("invoice.newCharge.chargeAmount")}
                </label>
                <input
                  className="admnnew__tax_modalinput"
                  placeholder={t("invoice.newCharge.chargeAmountPlaceholder")}
                  name="charge_amount"
                  value={data.charge_amount}
                  onChange={handleChange}
                  type="number"
                />
              </div>
            </div>
          </div>
          <div className="admnnew__tax_modalfooter">
            <div className="admnnew__tax_modalcncl" onClick={handleClose}>
              {t("common:actions.cancel")}
            </div>
            <div className="admnnew__tax_modalsave" onClick={handleSave}>
              {loading ? <Loader /> : t("invoice.newCharge.addEntry")}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
